
import { defineComponent, reactive, ref } from 'vue'
import QForm from 'quasar/src/components/form/QForm.js';
import { AuthenticationRequest, useSessionModule } from '@/modules/session'
import { requiredRule, useFormModule } from '@/modules/_shared/forms'
import SessionFormFieldUsername from '@/components/session/form-fields/username.vue'
import SessionFormFieldPassword from '@/components/session/form-fields/password.vue'

type LoginModel = Partial<AuthenticationRequest>

export default defineComponent({
    name: 'session-login-form',
    components: { SessionFormFieldPassword, SessionFormFieldUsername },
    setup (_, { emit }) {
        const { authenticateWithPassword } = useSessionModule()
        const loginInProgress = ref(false)
        const loginModel = reactive<LoginModel>({
            username: undefined,
            password: undefined
        })
        const { submitForm, createOnSuccess } = useFormModule()

        const form = ref<QForm>()
        const emitEvent = () => emit('formSent')
        const turnOnProgress = () => { loginInProgress.value = true }
        const turnOffProgress = () => { loginInProgress.value = false }

        const sendRequest = async () => {
            turnOnProgress()
            return authenticateWithPassword(loginModel as AuthenticationRequest)
        }

        const onSubmit = () => submitForm(
            form.value,
            sendRequest,
            createOnSuccess('Welcome!')
        )
            .then(turnOffProgress)
            .then(emitEvent)
            .catch(err => {
                turnOffProgress()
                throw err
            })

        return {
            requiredRule,
            loginModel,
            form,
            onSubmit,
            loginInProgress
        }
    }
})
